import first from 'lodash/first.js';
import flatMap from 'lodash/flatMap.js';
import has from 'lodash/has.js';

import axios from '@/plugins/axios.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default {
    state: {
        enrollment: null,
    },

    getters: {
        roles: state => state.enrollment?.roles,
        permissions: state => (has(state, 'enrollment.roles') ? flatMap(state.enrollment.roles, 'permissions') : []),
    },

    actions: {
        async fetch({ commit, rootState }, courseId) {
            const queryBuilder = new QueryBuilder('course-enrollments');

            queryBuilder.include(['roles.permissions']);

            queryBuilder.filters([
                { key: 'course_id', value: courseId },
                { key: 'user_id', value: rootState.Auth.user.id },
            ]);

            const response = await axios.get(queryBuilder.toUrl());

            if (response) commit('SET_ENROLLMENT', first(response.data.data));
        },
    },

    mutations: {
        SET_ENROLLMENT(state, enrollment) {
            state.enrollment = enrollment;
        },
    },
};
